"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nanoid = void 0;
// cross compatible nanoid implementation from
// https://github.com/ai/nanoid
const nanoid = (crypto) => (t = 21) => crypto
    .getRandomValues(new Uint8Array(t))
    .reduce((t, e) => (t += (e &= 63) < 36 ? e.toString(36) : e < 62 ? (e - 26).toString(36).toUpperCase() : e < 63 ? '_' : '-'), '');
exports.nanoid = nanoid;
